export default __webpack_public_path__ + "static/media/mistral_logo.f6702c05.PNG";